import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const [activeService, setActiveService] = useState(null);

  useEffect(() => {
    // Header scroll behavior
    let didScroll = false;
    let lastScrollTop = 0;
    const delta = 5;
    const navbarHeight = document.querySelector("header")?.offsetHeight || 0;

    const hasScrolled = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      if (Math.abs(lastScrollTop - scrollTop) <= delta) return;

      const header = document.querySelector(".header");
      if (scrollTop > lastScrollTop && scrollTop > navbarHeight) {
        header?.classList.remove("down");
        header?.classList.add("up");
      } else if (
        scrollTop + window.innerHeight <
        document.documentElement.scrollHeight
      ) {
        header?.classList.remove("up");
        header?.classList.add("down");
      }
      lastScrollTop = scrollTop;
    };

    const handleScroll = () => {
      didScroll = true;
    };

    window.addEventListener("scroll", handleScroll);

    const scrollInterval = setInterval(() => {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearInterval(scrollInterval);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.classList.toggle("open");
  };

  const toggleSubmenu = () => {
    setIsSubmenuOpen(!isSubmenuOpen);
    document.body.classList.toggle("open-menu");
  };

  const handleServiceHover = (service) => {
    setActiveService(service);
  };

  const closeMenu = () => {
    setIsSubmenuOpen(false);
    setIsMenuOpen(false);
    document.body.classList.remove("open-menu");
    document.body.classList.remove("open");
    document.body.classList.remove("hover");
  };

  const services = [
    {
      id: "product-design",
      name: "Digital Product Design",
      path: "/product-design",
      icon: (
        <svg
          width="44"
          height="44"
          viewBox="0 0 44 44"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 22C0 9.84943 9.84943 0 22 0C34.1506 0 44 9.84943 44 22C44 34.1506 34.1506 44 22 44C9.84943 44 0 34.1506 0 22ZM22 4C12.0586 4 4 12.0586 4 22C4 31.9414 12.0586 40 22 40C31.9414 40 40 31.9414 40 22C40 12.0586 31.9414 4 22 4Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8043 24.4398C13.3897 23.5031 14.6236 23.2184 15.5603 23.8038L18.5462 25.67L21.008 24.2633C21.6229 23.9119 22.3777 23.9119 22.9925 24.2633L25.4543 25.67L28.4403 23.8038C29.3769 23.2184 30.6108 23.5031 31.1963 24.4398C31.7817 25.3765 31.4969 26.6104 30.5603 27.1958L26.5603 29.6958C25.9358 30.0861 25.1474 30.1016 24.508 29.7363L22.0003 28.3033L19.4925 29.7363C18.8532 30.1016 18.0647 30.0861 17.4403 29.6958L13.4403 27.1958C12.5036 26.6104 12.2189 25.3765 12.8043 24.4398Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 10C22.7177 10 23.3804 10.3846 23.7365 11.0077L31.7365 25.0077C31.9092 25.3099 32 25.6519 32 26V40.336C32 41.4406 31.1046 42.336 30 42.336C28.8954 42.336 28 41.4406 28 40.336V26.5311L22 16.0311L16 26.5311V40.336C16 41.4406 15.1046 42.336 14 42.336C12.8954 42.336 12 41.4406 12 40.336V26C12 25.6519 12.0908 25.3099 12.2635 25.0077L20.2635 11.0077C20.6196 10.3846 21.2823 10 22 10Z"
          />
        </svg>
      ),
      image: "/assets/images/navbar/digitalproductdesign.webp",
      text: "From Concept to Creation:</br>UI Design Services Deliver Results",
    },
    {
      id: "mobile-development",
      name: "Mobile Development",
      path: "/mobile-development",
      icon: (
        <svg
          width="28"
          height="44"
          viewBox="0 0 28 44"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M11 38H17C17.2667 38 17.5 37.9 17.7 37.7C17.9 37.5 18 37.2667 18 37C18 36.7333 17.9 36.5 17.7 36.3C17.5 36.1 17.2667 36 17 36H11C10.7333 36 10.5 36.1 10.3 36.3C10.1 36.5 10 36.7333 10 37C10 37.2667 10.1 37.5 10.3 37.7C10.5 37.9 10.7333 38 11 38ZM4 44C2.9 44 1.958 43.608 1.174 42.824C0.390003 42.04 -0.00132994 41.0987 3.39559e-06 40V4C3.39559e-06 2.9 0.392003 1.958 1.176 1.174C1.96 0.390003 2.90134 -0.00132994 4 3.39559e-06H24C25.1 3.39559e-06 26.042 0.392003 26.826 1.176C27.61 1.96 28.0013 2.90134 28 4V40C28 41.1 27.608 42.042 26.824 42.826C26.04 43.61 25.0987 44.0013 24 44H4ZM4 30H24V10H4V30ZM4 34V40H24V34H4ZM4 6H24V4H4V6Z" />
        </svg>
      ),
      image: "/assets/images/navbar/mobile-development.webp",
      text: "Deliver a seamless, impactful experience<br>across all devices",
    },
    {
      id: "web-development",
      name: "Web Development",
      path: "/web-development",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M28.72 24C28.88 22.68 29 21.36 29 20C29 18.64 28.88 17.32 28.72 16H35.48C35.8 17.28 36 18.62 36 20C36 21.38 35.8 22.72 35.48 24M25.18 35.12C26.38 32.9 27.3 30.5 27.94 28H33.84C31.9023 31.3365 28.8282 33.864 25.18 35.12ZM24.68 24H15.32C15.12 22.68 15 21.36 15 20C15 18.64 15.12 17.3 15.32 16H24.68C24.86 17.3 25 18.64 25 20C25 21.36 24.86 22.68 24.68 24ZM20 35.92C18.34 33.52 17 30.86 16.18 28H23.82C23 30.86 21.66 33.52 20 35.92ZM12 12H6.16C8.07771 8.65443 11.1496 6.12297 14.8 4.88C13.6 7.1 12.7 9.5 12 12ZM6.16 28H12C12.7 30.5 13.6 32.9 14.8 35.12C11.1572 33.8633 8.08969 31.3354 6.16 28ZM4.52 24C4.2 22.72 4 21.38 4 20C4 18.62 4.2 17.28 4.52 16H11.28C11.12 17.32 11 18.64 11 20C11 21.36 11.12 22.68 11.28 24M20 4.06C21.66 6.46 23 9.14 23.82 12H16.18C17 9.14 18.34 6.46 20 4.06ZM33.84 12H27.94C27.314 9.52291 26.3871 7.13179 25.18 4.88C28.86 6.14 31.92 8.68 33.84 12ZM20 0C8.94 0 0 9 0 20C0 25.3043 2.10714 30.3914 5.85786 34.1421C7.71503 35.9993 9.91982 37.4725 12.3463 38.4776C14.7728 39.4827 17.3736 40 20 40C25.3043 40 30.3914 37.8929 34.1421 34.1421C37.8929 30.3914 40 25.3043 40 20C40 17.3736 39.4827 14.7728 38.4776 12.3463C37.4725 9.91982 35.9993 7.71503 34.1421 5.85786C32.285 4.00069 30.0802 2.5275 27.6537 1.52241C25.2272 0.517315 22.6264 0 20 0Z" />
        </svg>
      ),
      image: "/assets/images/navbar/web-development.webp",
      text: "Next-Generation Web Development Solutions<br> for the Modern Businesss",
    },
    {
      id: "backend-development",
      name: "Backend Development",
      path: "/backend-development",
      icon: (
        <svg
          width="36"
          height="38"
          viewBox="0 0 36 38"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M4 19C4 19.626 4.922 20.716 7.06 21.786C9.828 23.17 13.754 24 18 24C22.246 24 26.172 23.17 28.94 21.786C31.078 20.716 32 19.626 32 19V14.658C28.7 16.698 23.654 18 18 18C12.346 18 7.3 16.696 4 14.658V19ZM32 24.658C28.7 26.698 23.654 28 18 28C12.346 28 7.3 26.696 4 24.658V29C4 29.626 4.922 30.716 7.06 31.786C9.828 33.17 13.754 34 18 34C22.246 34 26.172 33.17 28.94 31.786C31.078 30.716 32 29.626 32 29V24.658ZM0 29V9C0 4.03 8.06 0 18 0C27.94 0 36 4.03 36 9V29C36 33.97 27.94 38 18 38C8.06 38 0 33.97 0 29ZM18 14C22.246 14 26.172 13.17 28.94 11.786C31.078 10.716 32 9.626 32 9C32 8.374 31.078 7.284 28.94 6.214C26.172 4.83 22.246 4 18 4C13.754 4 9.828 4.83 7.06 6.214C4.922 7.284 4 8.374 4 9C4 9.626 4.922 10.716 7.06 11.786C9.828 13.17 13.754 14 18 14Z" />
        </svg>
      ),
      image: "/assets/images/navbar/backend-development.webp",
      text: "The Hidden Hero :<br>How Backend Drives App Success",
    },
    {
      id: "blockchain-development",
      name: "Block Chain Development",
      path: "/blockchain-development",
      icon: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26 14.7822V27.5002H22V14.7822H26Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.8245 36.8179L22.8535 29.1383L25.1473 25.8613L36.1183 33.5409L33.8245 36.8179Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.8828 33.5403L22.8529 25.8613L25.1467 29.1383L14.1766 36.8173L11.8828 33.5403Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 6C22.067 6 20.5 7.567 20.5 9.5C20.5 11.433 22.067 13 24 13C25.933 13 27.5 11.433 27.5 9.5C27.5 7.567 25.933 6 24 6ZM16.5 9.5C16.5 5.35786 19.8579 2 24 2C28.1421 2 31.5 5.35786 31.5 9.5C31.5 13.6421 28.1421 17 24 17C19.8579 17 16.5 13.6421 16.5 9.5Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 35C7.067 35 5.5 36.567 5.5 38.5C5.5 40.433 7.067 42 9 42C10.933 42 12.5 40.433 12.5 38.5C12.5 36.567 10.933 35 9 35ZM1.5 38.5C1.5 34.3579 4.85786 31 9 31C13.1421 31 16.5 34.3579 16.5 38.5C16.5 42.6421 13.1421 46 9 46C4.85786 46 1.5 42.6421 1.5 38.5Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39 35C37.067 35 35.5 36.567 35.5 38.5C35.5 40.433 37.067 42 39 42C40.933 42 42.5 40.433 42.5 38.5C42.5 36.567 40.933 35 39 35ZM31.5 38.5C31.5 34.3579 34.8579 31 39 31C43.1421 31 46.5 34.3579 46.5 38.5C46.5 42.6421 43.1421 46 39 46C34.8579 46 31.5 42.6421 31.5 38.5Z"
          />
        </svg>
      ),
      image: "/assets/images/navbar/blockchain-development.webp",
      text: "Harness the Power of Decentralization :<br>Expert Blockchain Development Services",
    },
    {
      id: "ai-development",
      name: "AI Development",
      path: "/ai-development",
      icon: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_737_2)">
            <path
              d="M38 18C37.5877 18.0013 37.186 18.1302 36.8499 18.3689C36.5137 18.6076 36.2597 18.9445 36.1227 19.3333H32V16.6667H36C36.1768 16.6667 36.3464 16.5964 36.4714 16.4714C36.5964 16.3464 36.6667 16.1768 36.6667 16C36.6667 15.8232 36.5964 15.6536 36.4714 15.5286C36.3464 15.4036 36.1768 15.3333 36 15.3333H32V12.6667H36.6667C37.402 12.6667 38 12.0687 38 11.3333V9.87733C38.3888 9.74028 38.7257 9.48627 38.9644 9.15014C39.2031 8.81402 39.332 8.41227 39.3333 8C39.3333 6.89733 38.436 6 37.3333 6C36.2307 6 35.3333 6.89733 35.3333 8C35.3333 8.868 35.8927 9.60133 36.6667 9.87733V11.3333H32V10.6667C32 9.196 30.804 8 29.3333 8H28.6667V3.33333H30.1227C30.2597 3.72215 30.5137 4.05904 30.8499 4.29776C31.186 4.53648 31.5877 4.66535 32 4.66667C33.1027 4.66667 34 3.76933 34 2.66667C34 1.564 33.1027 0.666667 32 0.666667C31.5877 0.667988 31.186 0.796851 30.8499 1.03557C30.5137 1.27429 30.2597 1.61118 30.1227 2H28.6667C27.9313 2 27.3333 2.598 27.3333 3.33333V8H24.6667V4C24.6667 3.82319 24.5964 3.65362 24.4714 3.5286C24.3464 3.40357 24.1768 3.33333 24 3.33333C23.8232 3.33333 23.6536 3.40357 23.5286 3.5286C23.4036 3.65362 23.3333 3.82319 23.3333 4V8H20.6667V3.87733C21.0555 3.74028 21.3924 3.48627 21.6311 3.15014C21.8698 2.81402 21.9987 2.41227 22 2C22 0.897333 21.1027 0 20 0C18.8973 0 18 0.897333 18 2C18 2.868 18.5593 3.60133 19.3333 3.87733V8H16.6667V4C16.6667 3.82319 16.5964 3.65362 16.4714 3.5286C16.3464 3.40357 16.1768 3.33333 16 3.33333C15.8232 3.33333 15.6536 3.40357 15.5286 3.5286C15.4036 3.65362 15.3333 3.82319 15.3333 4V8H12.6667V3.33333C12.6667 2.598 12.0687 2 11.3333 2H9.87733C9.74028 1.61118 9.48627 1.27429 9.15014 1.03557C8.81402 0.796851 8.41227 0.667988 8 0.666667C6.89733 0.666667 6 1.564 6 2.66667C6 3.76933 6.89733 4.66667 8 4.66667C8.41227 4.66535 8.81402 4.53648 9.15014 4.29776C9.48627 4.05904 9.74028 3.72215 9.87733 3.33333H11.3333V8H10.6667C9.196 8 8 9.196 8 10.6667V11.3333H3.33333V9.87733C3.72215 9.74028 4.05904 9.48627 4.29776 9.15014C4.53648 8.81402 4.66535 8.41227 4.66667 8C4.66667 6.89733 3.76933 6 2.66667 6C1.564 6 0.666667 6.89733 0.666667 8C0.666667 8.868 1.226 9.60133 2 9.87733V11.3333C2 12.0687 2.598 12.6667 3.33333 12.6667H8V15.3333H4C3.82319 15.3333 3.65362 15.4036 3.5286 15.5286C3.40357 15.6536 3.33333 15.8232 3.33333 16C3.33333 16.1768 3.40357 16.3464 3.5286 16.4714C3.65362 16.5964 3.82319 16.6667 4 16.6667H8V19.3333H3.87733C3.74028 18.9445 3.48627 18.6076 3.15014 18.3689C2.81402 18.1302 2.41227 18.0013 2 18C0.897333 18 0 18.8973 0 20C0 21.1027 0.897333 22 2 22C2.41227 21.9987 2.81402 21.8698 3.15014 21.6311C3.48627 21.3924 3.74028 21.0555 3.87733 20.6667H8V23.3333H4C3.82319 23.3333 3.65362 23.4036 3.5286 23.5286C3.40357 23.6536 3.33333 23.8232 3.33333 24C3.33333 24.1768 3.40357 24.3464 3.5286 24.4714C3.65362 24.5964 3.82319 24.6667 4 24.6667H8V27.3333H3.33333C2.598 27.3333 2 27.9313 2 28.6667V30.1227C1.61118 30.2597 1.27429 30.5137 1.03557 30.8499C0.796851 31.186 0.667988 31.5877 0.666667 32C0.666667 33.1027 1.564 34 2.66667 34C3.76933 34 4.66667 33.1027 4.66667 32C4.66535 31.5877 4.53648 31.186 4.29776 30.8499C4.05904 30.5137 3.72215 30.2597 3.33333 30.1227V28.6667H8V29.3333C8 30.804 9.196 32 10.6667 32H11.3333V36.6667H9.87733C9.74028 36.2778 9.48627 35.941 9.15014 35.7022C8.81402 35.4635 8.41227 35.3347 8 35.3333C6.89733 35.3333 6 36.2307 6 37.3333C6 38.436 6.89733 39.3333 8 39.3333C8.41227 39.332 8.81402 39.2031 9.15014 38.9644C9.48627 38.7257 9.74028 38.3888 9.87733 38H11.3333C12.0687 38 12.6667 37.402 12.6667 36.6667V32H15.3333V36C15.3333 36.1768 15.4036 36.3464 15.5286 36.4714C15.6536 36.5964 15.8232 36.6667 16 36.6667C16.1768 36.6667 16.3464 36.5964 16.4714 36.4714C16.5964 36.3464 16.6667 36.1768 16.6667 36V32H19.3333V36.1227C18.9445 36.2597 18.6076 36.5137 18.3689 36.8499C18.1302 37.186 18.0013 37.5877 18 38C18 39.1027 18.8973 40 20 40C21.1027 40 22 39.1027 22 38C21.9987 37.5877 21.8698 37.186 21.6311 36.8499C21.3924 36.5137 21.0555 36.2597 20.6667 36.1227V32H23.3333V36C23.3333 36.1768 23.4036 36.3464 23.5286 36.4714C23.6536 36.5964 23.8232 36.6667 24 36.6667C24.1768 36.6667 24.3464 36.5964 24.4714 36.4714C24.5964 36.3464 24.6667 36.1768 24.6667 36V32H27.3333V36.6667C27.3333 37.402 27.9313 38 28.6667 38H30.1227C30.2597 38.3888 30.5137 38.7257 30.8499 38.9644C31.186 39.2031 31.5877 39.332 32 39.3333C33.1027 39.3333 34 38.436 34 37.3333C34 36.2307 33.1027 35.3333 32 35.3333C31.5877 35.3347 31.186 35.4635 30.8499 35.7022C30.5137 35.941 30.2597 36.2778 30.1227 36.6667H28.6667V32H29.3333C30.804 32 32 30.804 32 29.3333V28.6667H36.6667V30.1227C36.2778 30.2597 35.941 30.5137 35.7022 30.8499C35.4635 31.186 35.3347 31.5877 35.3333 32C35.3333 33.1027 36.2307 34 37.3333 34C38.436 34 39.3333 33.1027 39.3333 32C39.332 31.5877 39.2031 31.186 38.9644 30.8499C38.7257 30.5137 38.3888 30.2597 38 30.1227V28.6667C38 27.9313 37.402 27.3333 36.6667 27.3333H32V24.6667H36C36.1768 24.6667 36.3464 24.5964 36.4714 24.4714C36.5964 24.3464 36.6667 24.1768 36.6667 24C36.6667 23.8232 36.5964 23.6536 36.4714 23.5286C36.3464 23.4036 36.1768 23.3333 36 23.3333H32V20.6667H36.1227C36.2597 21.0555 36.5137 21.3924 36.8499 21.6311C37.186 21.8698 37.5877 21.9987 38 22C39.1027 22 40 21.1027 40 20C40 18.8973 39.1027 18 38 18ZM37.3333 7.33333C37.5101 7.33333 37.6797 7.40357 37.8047 7.5286C37.9298 7.65362 38 7.82319 38 8C38 8.17681 37.9298 8.34638 37.8047 8.4714C37.6797 8.59643 37.5101 8.66667 37.3333 8.66667C37.1565 8.66667 36.987 8.59643 36.8619 8.4714C36.7369 8.34638 36.6667 8.17681 36.6667 8C36.6667 7.82319 36.7369 7.65362 36.8619 7.5286C36.987 7.40357 37.1565 7.33333 37.3333 7.33333ZM32 2C32.1768 2 32.3464 2.07024 32.4714 2.19526C32.5964 2.32029 32.6667 2.48986 32.6667 2.66667C32.6667 2.84348 32.5964 3.01305 32.4714 3.13807C32.3464 3.2631 32.1768 3.33333 32 3.33333C31.8232 3.33333 31.6536 3.2631 31.5286 3.13807C31.4036 3.01305 31.3333 2.84348 31.3333 2.66667C31.3333 2.48986 31.4036 2.32029 31.5286 2.19526C31.6536 2.07024 31.8232 2 32 2ZM20 1.33333C20.1768 1.33333 20.3464 1.40357 20.4714 1.5286C20.5964 1.65362 20.6667 1.82319 20.6667 2C20.6667 2.17681 20.5964 2.34638 20.4714 2.4714C20.3464 2.59643 20.1768 2.66667 20 2.66667C19.8232 2.66667 19.6536 2.59643 19.5286 2.4714C19.4036 2.34638 19.3333 2.17681 19.3333 2C19.3333 1.82319 19.4036 1.65362 19.5286 1.5286C19.6536 1.40357 19.8232 1.33333 20 1.33333ZM8 3.33333C7.82319 3.33333 7.65362 3.2631 7.5286 3.13807C7.40357 3.01305 7.33333 2.84348 7.33333 2.66667C7.33333 2.48986 7.40357 2.32029 7.5286 2.19526C7.65362 2.07024 7.82319 2 8 2C8.17681 2 8.34638 2.07024 8.4714 2.19526C8.59643 2.32029 8.66667 2.48986 8.66667 2.66667C8.66667 2.84348 8.59643 3.01305 8.4714 3.13807C8.34638 3.2631 8.17681 3.33333 8 3.33333ZM2.66667 7.33333C2.84348 7.33333 3.01305 7.40357 3.13807 7.5286C3.2631 7.65362 3.33333 7.82319 3.33333 8C3.33333 8.17681 3.2631 8.34638 3.13807 8.4714C3.01305 8.59643 2.84348 8.66667 2.66667 8.66667C2.48986 8.66667 2.32029 8.59643 2.19526 8.4714C2.07024 8.34638 2 8.17681 2 8C2 7.82319 2.07024 7.65362 2.19526 7.5286C2.32029 7.40357 2.48986 7.33333 2.66667 7.33333ZM2 20.6667C1.82319 20.6667 1.65362 20.5964 1.5286 20.4714C1.40357 20.3464 1.33333 20.1768 1.33333 20C1.33333 19.8232 1.40357 19.6536 1.5286 19.5286C1.65362 19.4036 1.82319 19.3333 2 19.3333C2.17681 19.3333 2.34638 19.4036 2.4714 19.5286C2.59643 19.6536 2.66667 19.8232 2.66667 20C2.66667 20.1768 2.59643 20.3464 2.4714 20.4714C2.34638 20.5964 2.17681 20.6667 2 20.6667ZM2.66667 32.6667C2.48986 32.6667 2.32029 32.5964 2.19526 32.4714C2.07024 32.3464 2 32.1768 2 32C2 31.8232 2.07024 31.6536 2.19526 31.5286C2.32029 31.4036 2.48986 31.3333 2.66667 31.3333C2.84348 31.3333 3.01305 31.4036 3.13807 31.5286C3.2631 31.6536 3.33333 31.8232 3.33333 32C3.33333 32.1768 3.2631 32.3464 3.13807 32.4714C3.01305 32.5964 2.84348 32.6667 2.66667 32.6667ZM8 38C7.82319 38 7.65362 37.9298 7.5286 37.8047C7.40357 37.6797 7.33333 37.5101 7.33333 37.3333C7.33333 37.1565 7.40357 36.987 7.5286 36.8619C7.65362 36.7369 7.82319 36.6667 8 36.6667C8.17681 36.6667 8.34638 36.7369 8.4714 36.8619C8.59643 36.987 8.66667 37.1565 8.66667 37.3333C8.66667 37.5101 8.59643 37.6797 8.4714 37.8047C8.34638 37.9298 8.17681 38 8 38ZM20 38.6667C19.8232 38.6667 19.6536 38.5964 19.5286 38.4714C19.4036 38.3464 19.3333 38.1768 19.3333 38C19.3333 37.8232 19.4036 37.6536 19.5286 37.5286C19.6536 37.4036 19.8232 37.3333 20 37.3333C20.1768 37.3333 20.3464 37.4036 20.4714 37.5286C20.5964 37.6536 20.6667 37.8232 20.6667 38C20.6667 38.1768 20.5964 38.3464 20.4714 38.4714C20.3464 38.5964 20.1768 38.6667 20 38.6667ZM32 36.6667C32.1768 36.6667 32.3464 36.7369 32.4714 36.8619C32.5964 36.987 32.6667 37.1565 32.6667 37.3333C32.6667 37.5101 32.5964 37.6797 32.4714 37.8047C32.3464 37.9298 32.1768 38 32 38C31.8232 38 31.6536 37.9298 31.5286 37.8047C31.4036 37.6797 31.3333 37.5101 31.3333 37.3333C31.3333 37.1565 31.4036 36.987 31.5286 36.8619C31.6536 36.7369 31.8232 36.6667 32 36.6667ZM37.3333 32.6667C37.1565 32.6667 36.987 32.5964 36.8619 32.4714C36.7369 32.3464 36.6667 32.1768 36.6667 32C36.6667 31.8232 36.7369 31.6536 36.8619 31.5286C36.987 31.4036 37.1565 31.3333 37.3333 31.3333C37.5101 31.3333 37.6797 31.4036 37.8047 31.5286C37.9298 31.6536 38 31.8232 38 32C38 32.1768 37.9298 32.3464 37.8047 32.4714C37.6797 32.5964 37.5101 32.6667 37.3333 32.6667ZM30.6667 29.3333C30.6667 30.0687 30.0687 30.6667 29.3333 30.6667H10.6667C9.93133 30.6667 9.33333 30.0687 9.33333 29.3333V10.6667C9.33333 9.93133 9.93133 9.33333 10.6667 9.33333H29.3333C30.0687 9.33333 30.6667 9.93133 30.6667 10.6667V29.3333ZM38 20.6667C37.8232 20.6667 37.6536 20.5964 37.5286 20.4714C37.4036 20.3464 37.3333 20.1768 37.3333 20C37.3333 19.8232 37.4036 19.6536 37.5286 19.5286C37.6536 19.4036 37.8232 19.3333 38 19.3333C38.1768 19.3333 38.3464 19.4036 38.4714 19.5286C38.5964 19.6536 38.6667 19.8232 38.6667 20C38.6667 20.1768 38.5964 20.3464 38.4714 20.4714C38.3464 20.5964 38.1768 20.6667 38 20.6667Z"
              fill="white"
            />
            <path
              d="M17.0071 14.8067C16.9011 14.332 16.4871 14 15.9997 14C15.5124 14 15.0984 14.332 14.9917 14.808L12.6817 25.1887C12.6436 25.3613 12.6755 25.542 12.7705 25.6912C12.8655 25.8403 13.0158 25.9456 13.1884 25.984C13.361 26.0214 13.5414 25.9892 13.6903 25.8943C13.8392 25.7994 13.9447 25.6496 13.9837 25.4773L14.7577 21.9993H17.2411L18.0151 25.4773C18.0533 25.6501 18.1587 25.8005 18.3079 25.8956C18.4571 25.9907 18.638 26.0226 18.8107 25.9843C18.9835 25.9461 19.1339 25.8407 19.229 25.6915C19.3241 25.5423 19.356 25.3614 19.3177 25.1887L17.0071 14.8067ZM15.0551 20.6667L16.0004 16.4187L16.9457 20.6667H15.0551ZM25.3331 15.3333C25.5099 15.3333 25.6794 15.2631 25.8045 15.1381C25.9295 15.013 25.9997 14.8435 25.9997 14.6667C25.9997 14.4899 25.9295 14.3203 25.8045 14.1953C25.6794 14.0702 25.5099 14 25.3331 14H21.3331C21.1562 14 20.9867 14.0702 20.8617 14.1953C20.7366 14.3203 20.6664 14.4899 20.6664 14.6667C20.6664 14.8435 20.7366 15.013 20.8617 15.1381C20.9867 15.2631 21.1562 15.3333 21.3331 15.3333H22.6664V24.6667H21.3331C21.1562 24.6667 20.9867 24.7369 20.8617 24.8619C20.7366 24.987 20.6664 25.1565 20.6664 25.3333C20.6664 25.5101 20.7366 25.6797 20.8617 25.8047C20.9867 25.9298 21.1562 26 21.3331 26H25.3331C25.5099 26 25.6794 25.9298 25.8045 25.8047C25.9295 25.6797 25.9997 25.5101 25.9997 25.3333C25.9997 25.1565 25.9295 24.987 25.8045 24.8619C25.6794 24.7369 25.5099 24.6667 25.3331 24.6667H23.9997V15.3333H25.3331Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_737_2">
              <rect width="40" height="40" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      image: "/assets/images/navbar/ai-developments.webp",
      text: "Full-Spectrum Defense :<br>Safeguarding Your Software Ecosystem",
    },
  ];

  return (
    <header className="header fixed">
      <div className="container flex">
        <div className="logo">
          <div className="logo">
            <Link to="/">
              <img src="/assets/images/logo.svg" alt="Logo" />
            </Link>
          </div>
        </div>
        <a
          href="#"
          className="nav-trigger pull-right"
          onClick={(e) => {
            e.preventDefault();
            toggleMenu();
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </a>
        <nav className={`ml-auto flex nav ${isMenuOpen ? "open" : ""}`}>
          <ul>
            <li>
              <Link to="/portfolio" onClick={closeMenu}>
                Portfolio
              </Link>
            </li>
            <li
              className="submenu"
              onMouseEnter={() => {
                setIsSubmenuOpen(true);
                document.body.classList.add("hover");
              }}
              onMouseLeave={() => {
                setIsSubmenuOpen(false);
                document.body.classList.remove("hover");
              }}
            >
              <a>Services</a>
              <a
                href="#"
                className="menu-arrow"
                alt="Arrow-7"
                aria-label="More Menu"
                onClick={(e) => {
                  e.preventDefault();
                  toggleSubmenu();
                }}
              ></a>
              <div className={`sub-menu ${isSubmenuOpen ? "open" : ""}`}>
                <div className="container">
                  <ul className="menu">
                    <li className={activeService === null ? "active" : ""}>
                      <div className="megadrop">
                        <img
                          src="/assets/images/navbar/menuDefault.webp"
                          alt="Menu Default"
                        />
                      </div>
                    </li>
                    {services.map((service) => (
                      <li
                        key={service.id}
                        className={activeService === service.id ? "active" : ""}
                        onMouseEnter={() => handleServiceHover(service.id)}
                        onMouseLeave={() => handleServiceHover(null)}
                      >
                        <Link to={service.path} onClick={closeMenu}>
                          <strong>{service.icon}</strong>
                          <span>{service.name}</span>
                        </Link>
                        <div className="megadrop">
                          <img src={service.image} alt={service.name} />
                        </div>
                        <div
                          className="menu-text"
                          dangerouslySetInnerHTML={{ __html: service.text }}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </li>
            <li>
              <Link to="/about-us" onClick={closeMenu}>
                About us
              </Link>
            </li>
            <li style={{ paddingRight: "16px" }}>
              <Link to="/contact-us" onClick={closeMenu}>
                Contact us
              </Link>
            </li>
          </ul>
          <div className="inquiry">
            <h2 className="mobile">
              Ready to <span>Build Together?</span>
            </h2>
            <Link
              to="/start-a-project"
              className="btn btn-outline inquiry-link"
              onClick={closeMenu}
            >
              <span>Start A Project</span>
              <span className="arrow" style={{ marginLeft: "4px" }}></span>
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
